import React, { SVGProps } from 'react';

const SvgHotJobFromFacebook = (props: SVGProps<SVGSVGElement>) => (
    <svg width={52.138} viewBox="0 0 52.138 52.138" {...props}>
        <g data-name="Hot Job From Facebook" transform="translate(-.001)">
            <circle
                data-name="Ellipse 34"
                cx={25.246}
                cy={25.246}
                r={25.246}
                transform="translate(.824 .823)"
                fill="#12b05e"
            />
            <path
                data-name="Path 297"
                d="M26.07.823a25.478 25.478 0 0 0-3.293.214 25.248 25.248 0 0 1 0 50.064A25.247 25.247 0 1 0 26.07.823Z"
                fill="#03984b"
            />
            <path
                data-name="Path 298"
                d="M17.289 26.078v1.1H9.605v7.688h7.684v14.9a25.13 25.13 0 0 0 7.683 1.546v-16.45h12.074v-7.685H24.972v-1.1c0-4.246 3.44-6.59 7.683-6.59h4.391v-7.688h-4.391c-7.88.001-15.366 6.394-15.366 14.279Z"
                fill="#fcfcfc"
            />
            <path
                data-name="Path 299"
                d="M44.5 7.635A26.07 26.07 0 1 0 17 50.516a.825.825 0 0 0 .944-.275.853.853 0 0 0 .166-.52V34.85a.823.823 0 0 0-.823-.823h-6.86V27.99h6.86a.823.823 0 0 0 .823-.823v-1.1c0-7.163 6.8-13.446 14.544-13.446h3.567v6.039h-3.565a9.5 9.5 0 0 0-5.948 1.883 6.832 6.832 0 0 0-2.558 5.526v1.1a.823.823 0 0 0 .823.823h3.246a.823.823 0 0 0 .823-.823.823.823 0 0 0-.823-.823H25.8v-.274c0-4.253 3.7-5.763 6.86-5.763h4.391a.823.823 0 0 0 .823-.823V11.8a.823.823 0 0 0-.823-.823h-4.395a16.934 16.934 0 0 0-11.191 4.392 14.4 14.4 0 0 0-5 10.7v.274h-6.86a.823.823 0 0 0-.823.823v7.684a.823.823 0 0 0 .823.823h6.86v12.856a24.434 24.434 0 1 1 9.6 1.962h-.274V35.673h11.255a.823.823 0 0 0 .823-.823v-7.684a.823.823 0 0 0-.823-.823h-4.818a.823.823 0 0 0-.823.823.823.823 0 0 0 .823.823h4v6.037H24.972a.823.823 0 0 0-.823.823v16.44a.823.823 0 0 0 .787.822c.408.017.779.026 1.134.026A26.069 26.069 0 0 0 44.5 7.635Z"
            />
        </g>
    </svg>
);
export default SvgHotJobFromFacebook;
